
import React from 'react';
import { Search } from 'lucide-react';
import { Input } from "@/components/ui/input";
import { VisaRequirementsFilter } from './VisaRequirementsFilter';
import { RegionFilter } from '../search/components/RegionFilter';

interface VisaFilterProps {
  visaTypeFilter: 'all' | 'visa_free' | 'visa_on_arrival' | 'e_visa' | 'visa_required';
  regionFilter: string | null;
  searchQuery: string;
  onVisaTypeFilterChange: (visaType: 'all' | 'visa_free' | 'visa_on_arrival' | 'e_visa' | 'visa_required') => void;
  onRegionFilterChange: (region: string) => void;
  onSearchChange: (search: string) => void;
}

export const VisaFilter = ({
  visaTypeFilter,
  regionFilter,
  searchQuery,
  onVisaTypeFilterChange,
  onRegionFilterChange,
  onSearchChange,
}: VisaFilterProps) => {
  return (
    <div className="space-y-4">
      <div className="relative">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
        <Input
          className="pl-10"
          placeholder="Search country..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <VisaRequirementsFilter 
          onFilterChange={onVisaTypeFilterChange}
          currentFilter={visaTypeFilter}
        />
        <RegionFilter 
          value={regionFilter} 
          onChange={onRegionFilterChange} 
        />
      </div>
    </div>
  );
};
